import { createContext } from 'react';
import IO, { Socket } from 'socket.io-client';
import appConfig from '../Utils/config'

export const socket: Socket = IO('' + appConfig.socketUrl, { autoConnect: false });
export const SocketContext = createContext(socket);
